import { styled } from "styled-components";

export const CustomFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const RadioBoxContainer = styled.div`
  padding: 0 12px;
  border: 2px dashed #d1dbe3;
  border-radius: 4px;
`;

export const TextFieldsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 100%;
`;

interface ITextFieldWrapper {
  size?: number;
}

export const TextFieldWrapper = styled.div<ITextFieldWrapper>`
  flex: ${(props) => props.size || 1};
  min-width: 0;
`;
